import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.thumbs = {
      display: ['none', null, 'block'],
      width: '80px',
      minWidth: '80px',
      mr: '28px',
      position: 'relative',
      height: [
        'calc((80px * 5) + (12px * 4))',
        null,
        null,
        'calc((80px * 6) + (12px * 5))',
      ],
    };

    this.swiper = {
      height: '100%',
      '.swiper-slide': {
        pb: '100%',
        height: 'auto !important',
        position: 'relative',
      },
    };

    this.thumb = {
      width: '100%',
      height: '100%',
      cursor: 'pointer',
      borderRadius: '4px',
      position: 'absolute',
      overflow: 'hidden',
      top: 0,
      left: 0,
      transition: 'all .25s ease-in-out',
      '&:hover': {
        opacity: 1,
      },

      inactive: {
        border: (t) => `1px solid ${t.colors.gray}`,
      },

      active: {
        border: (t) => `1px solid ${t.colors.text}`,
      },

      default: {
        image: {
          position: 'absolute',
          width: '100%',
          height: '80px',
          display: 'block',
          objectFit: 'cover',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
        },

        text: {
          position: 'absolute',
          transform: 'translate(-50%, -50%)',
          top: '50%',
          left: '50%',
          zIndex: 1,
          fontSize: 1,
          textAlign: 'center',
        },
      },
    };

    this.play = {
      color: 'white',
      position: 'absolute',
      width: '38px',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
    };
  })()
);
